<template>
    <v-dialog v-model="showDialog" max-width="615px" persistent>
        <v-card class="pa-8 rounded-xl" flat>
            <v-card-title>
                <v-row>
                    <v-col>
                        <v-row class="text-large better-break" justify="center">
                            <span>{{$t('user-settings.communicationDialogTitle')}}</span>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text class="my-0 py-0">
                <v-stepper v-model="step" flat>
                    <v-stepper-items>
                        <v-stepper-content class="pa-0" step="1">
                            <v-container>
                                <v-row class="d-block my-4">
                                    <v-form ref="step1Form" v-model="step1Valid">
                                        <v-text-field v-if="communicationType == 0"
                                                      v-model="communicationValue"
                                                      id="email"
                                                      ref="email"
                                                      :label="$t('email')"
                                                      class="text-normal"
                                                      outlined hide-details
                                                      maxlength="255"
                                                      type="email"
                                                      :rules="emailRules" 
                                                      @change="onCommunicationValueChange"/>

                                         <VuePhoneNumberInput v-else
                                                              v-model="communicationValueTemp"
                                                                class="text-normal ml-1 mb-8"
                                                                color="#0078A2"
                                                                :error="phoneNumberError"
                                                                :translations="$i18n.locale == 'fr' ? phoneTraductionFR : phoneTraductionEN"
                                                                error-color="#ff5252"
                                                                default-country-code="CA"
                                                                no-country-selector
                                                                no-validator-state
                                                                no-example
                                                                @update="onPhoneNumberUpdate" />
                                    </v-form>
                                </v-row>
                                <v-row justify="space-between" class="mx-0">
                                    <v-hover v-slot="{hover}">
                                        <v-btn class="text-none text-normal white--text"
                                               :color="hover ? 'buttonHover' : 'primary'"
                                               :disabled="isFormProcessing"
                                               min-width="33%"
                                               x-large depressed
                                               @click="onCancel">
                                            {{ $t('cancel') }}
                                        </v-btn>
                                    </v-hover>
                                    <v-hover v-slot="{hover}">
                                        <v-btn class="text-none text-normal ml-4 text-none text-normal white--text"
                                               min-width="33%"
                                               x-large depressed
                                               :color="hover ? 'buttonHover' : 'primary'"
                                               :disabled="!isCommunicationValueChanged"
                                               @click="onOk">
                                            {{ $t('ok')  }}
                                        </v-btn>
                                    </v-hover>
                                </v-row>
                            </v-container>
                        </v-stepper-content>
                        <v-stepper-content class="pa-0" step="2">
                            <v-container>
                                <v-card-title class="d-block text-center card-title">{{$t('user-settings.mfaTitle')}}</v-card-title>
                                <v-card-subtitle class="text-center card-subtitle">{{communicationType == 1 ? $t('user-settings.mfaBySMSSubTitle', { 'phoneNumber': communicationValue}) : $t('user-settings.mfaByEmailSubTitle', { 'email': communicationValue})}}</v-card-subtitle>
                                <v-alert v-if="alert.message" class="mx-4 pa-3 d-block" dense dark :type="alert.type">{{$t(alert.message)}}</v-alert>
                                <v-form ref="step2Form" v-model="step2Valid">
                                    <v-row class="my-4">
                                        <v-row>
                                            <v-otp-input v-model="validationCode"
                                                         length="7"
                                                         type="number"
                                                         class="mx-6"
                                                         :class="this.$vuetify.breakpoint.smAndDown ? 'v-otp-input-mobile' : ''"
                                                         :rules="validationCodeRules"
                                                         @finish="onFinish">

                                            </v-otp-input>
                                        </v-row>
                                    </v-row>
                                    <v-row v-if="!waitToResend" class="d-flex justify-space-between my-4">
                                        <v-hover v-slot="{hover}">
                                            <v-btn class="text-none text-small"
                                                   text plain
                                                   :color="hover ? 'linkHover' : 'primary'"
                                                   @click="sendContactValidationCode(true)">
                                                {{$t('user-settings.mfaResendCode')}}
                                            </v-btn>
                                        </v-hover>
                                    </v-row>
                                    <v-row v-else class="my-4">
                                        <span class="px-4 text-small">{{$t('user-settings.timeLeftBeforeResend',{ second: this.timeLeftBeforeResend })}}</span>
                                    </v-row>
                                    <v-row justify="space-between" class="mx-0">
                                        <v-hover v-slot="{hover}">
                                            <v-btn class="text-none text-normal min-height-1"
                                                   dark
                                                   depressed
                                                   :color="hover ? 'buttonHover' : 'primary'"
                                                   @click="onPrevious"
                                                   :min-width="$vuetify.breakpoint.smAndDown ? '150px' : '40%'">
                                                {{$t('previous')}}
                                            </v-btn>
                                        </v-hover>
                                        <v-hover v-slot="{hover}">
                                            <v-btn class="text-none text-normal min-height-1"
                                                   :disabled="!isStep2ButtonActive"
                                                   :dark="isStep2ButtonActive"
                                                   depressed
                                                   :color="hover ? 'buttonHover' : 'primary'"
                                                   @click="onValidate"
                                                   :min-width="$vuetify.breakpoint.smAndDown ? '150px' : '40%'">
                                                {{$t('verify')}}
                                                &nbsp;
                                                <v-progress-circular v-if="formProcess" indeterminate
                                                                     color="primary">
                                                </v-progress-circular>
                                            </v-btn>
                                        </v-hover>
                                    </v-row>

                                </v-form>
                            </v-container>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-card-text>
            <v-card-actions>
            </v-card-actions>
            
        </v-card>
    </v-dialog>
</template>
<style scoped>
    .better-break {
        word-break: normal;
        word-wrap: normal;
        text-align: center;
    }

    .v-otp-input >>> input {
        font-size: 40px !important;
        min-height: 87px !important;
        border-radius: 10px;
        text-align: center !important;
    }

    .v-otp-input-mobile >>> input {
        font-size: 20px !important;
        min-height: 48px !important;
        border-radius: 5px;
        text-align: center !important;
    }
</style>

<script>
    import VuePhoneNumberInput from 'vue-phone-number-input';
    import { mapState, mapActions } from "vuex";
    import { accountService } from "../services";
    export default {
        name: "communicationComponent",
        props: {
            value: undefined,
            communicationType: {
                type: Number,
                default: 0 // 0 = Email, 1 = SMS
            },
        },
        components: { VuePhoneNumberInput },
        data() {
            return {
                showDialog: true,
                communicationValue: null,
                communicationValueOriginal: null,
                communicationValueTemp: null,
                communicationValueChanged: false,
                validationCode: '',
                step1Valid: false,
                step2Valid: false,
                step: 1,
                formProcess: false,
                interval: null,
                waitToResend: true,
                retryResendCount: 0,
                resendDelays: [30, 40, 60, 90, 120],
                timeLeftBeforeResend: 0,
                phoneNumberError: false,
                phoneTraductionFR: {
                    "countrySelectorLabel": 'Code pays',
                    "countrySelectorError": 'Choisir un pays',
                    "phoneNumberLabel": 'Numéro de téléphone',
                    "example": 'Exemple :'
                },
                phoneTraductionEN: {
                    "countrySelectorLabel": 'Country Code',
                    "countrySelectorError": 'Choose a country',
                    "phoneNumberLabel": 'Phone Number',
                    "example": 'Example :'
                },
                emailRules: [
                    v => !!v || this.$t('requiredField'),
                    v => (v && v.length >= 6 && v.length <= 256) || 'InvalidLength',
                    v => (v && String(v).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/) != null || 'InvalidFormat'),
                    v => (v && v.substring(0, v.indexOf("@")).length <= 64 || 'InvalidFormat')
                ],
                validationCodeRules: [
                    v => !!v || '',
                    v => (v && v.length == 7) || '',
                ],
            }
        },
        computed: {
            ...mapState({ alert: state => state.alert }),
            isFormProcessing() {
                return this.formProcess;
            },
            isStep2ButtonActive() {
                return !this.formProcess && this.step2Valid;
            },
            isCommunicationValueChanged() {
                if (this.communicationType == 0)
                    return ((this.communicationValue != this.communicationValueOriginal) && this.step1Valid)
                else
                    return ((this.communicationValue != this.communicationValueOriginal) && !this.phoneNumberError)
            }
        },
        mounted() {
            this.communicationValue = this.value;
            this.communicationValueOriginal = this.value;
            this.communicationValueTemp = this.value;
            this.communicationValueChanged = false;
        },
        watch: {
            value(newVal) {
                this.communicationValue = newVal;
                this.communicationValueOriginal = newVal;
                this.communicationValueTemp = newVal;
                this.communicationValueChanged = false;
                this.formProcess = false;
            }
        },
        methods: {
            ...mapActions({ clearAlert: 'alert/clear' }),
            ...mapActions({ errorAlert: 'alert/error' }),
            ...mapActions({ successAlert: 'alert/success' }),

            onOk() {
                if (this.communicationValueChanged)
                    this.sendContactValidationCode(false);
                this.step = 2;
            },
            onCancel() {
                this.$emit('cancel');
            },
            onFinish(code) {
                this.validationCode = code;
            },
            sendContactValidationCode(resend = false) {
                if ((this.timeLeftBeforeResend == 0) || (this.communicationValueChanged)) {
                    this.formProcess = true;
                    this.validationCode = '';
                    let contactValidationCodeRequest = { ContactValue: this.communicationValue, CommunicationType: this.communicationType }

                    accountService.sendContactValidationCode(contactValidationCodeRequest)
                        .then((response) => {
                            if (response.data.success) {
                                if (resend) {
                                    this.successAlert('user-settings.mfacode-resend');
                                    setTimeout(() => {
                                        this.clearAlert();
                                    }, 7000);
                                }
                                this.timeLeftBeforeResend = this.resendDelays[this.retryResendCount];
                                this.retryResendCount = this.retryResendCount == 4 ? this.retryResendCount : this.retryResendCount + 1;
                                this.setResendInterval();
                            }
                            else
                                this.errorAlert('user-settings.mfaCodeResendError');
                        })
                        .catch(error => {
                            this.errorAlert(error.message);
                        });;

                    this.formProcess = false;
                }
                
            },
            onValidate() {
                this.formProcess = true;
                let contactValidationCodeRequest = { ContactValue: this.communicationValue, ContactValidationCode: this.validationCode }
                accountService.validateContactValidationCode(contactValidationCodeRequest)
                    .then((response) => {
                        if (response.data.success) {
                            this.$emit('commit', this.communicationValue);
                        }
                        else if (response.data.error) 
                            this.errorAlert(response.data.error);
                        else
                            this.errorAlert('user-settings.mfaCodeValidationError');
                    })
                    .catch(error => {
                        this.errorAlert(error.message);
                    });;

                this.formProcess = false;
  
            },
            setResendInterval() {
                this.waitToResend = true;
                clearInterval(this.interval);

                this.interval = setInterval(() => {
                    this.timeLeftBeforeResend--;
                    if (this.timeLeftBeforeResend == 0) {
                        this.waitToResend = false;
                        clearInterval(this.interval);
                    }
                }, 1000);

            },
            onPrevious() {
                this.step = 1;
                this.validationCode = '';
                this.communicationValueChanged = false;
            },

            onPhoneNumberUpdate(payload) {
                this.communicationValue = payload.e164;
                this.phoneNumberError = !payload.isValid;
                if (payload.isValid)
                    this.onCommunicationValueChange();
            },

            onCommunicationValueChange() {
                this.communicationValueChanged = true;
            }
        }
    }
</script>